const content = [
  {
    name: 'Main',
    rows: [
      {
        name: 'Home',
        icon: 'IosHome',
        redirect: '/'
      },
      {
        name: 'Calendar',
        icon: 'MdCalendar',
        redirect: '/dashboard/calendar'
      }
    ]
  },
  {
    name: 'Content',
    rows: [
      {
        name: 'Event Bookings',
        icon: 'IosBookmarksOutline',
        redirect: '/dashboard/eventBookings'
      },
      {
        name: 'Events',
        icon: 'MdContacts',
        redirect: '/dashboard/events'
      },
      // {
      //   name: 'Play Only Tickets',
      //   icon: 'IosPlanet'
      // },
      // {
      //   name: 'Memberships',
      //   icon: 'MdPerson'
      // },
      // {
      //   name: 'Online Users',
      //   icon: 'IosGlobeOutline'
      // },
      // {
      //   name: 'Onsite Users',
      //   icon: 'IosWalk'
      // },
      // {
      //   name: 'Customer Service',
      //   icon: 'IosChatbubbles'
      // },
      {
        name: 'Party Additions',
        icon: 'MdCart',
        redirect: '/dashboard/partyAdditions'
      },
      {
        name: 'Themes',
        icon: 'MdBowtie',
        redirect: '/dashboard/themes'
      },
      {
        name: 'Mascot Additions',
        icon: 'MdBody',
        redirect: '/dashboard/mascotAdditions'
      },
      {
        name: 'News',
        icon: 'MdWifi',
        redirect: '/dashboard/news'
      },
      {
        name: 'Banners',
        icon: 'MdBrowsers',
        redirect: '/dashboard/banner'
      },
      {
        name: 'Insights',
        icon: 'MdTrendingUp',
        redirect: '/dashboard/insights'
      },
      {
        name: 'Inventory',
        icon: 'MdArchive',
        redirect: '/dashboard/inventory'
      },
      {
        name: 'Calendar Date Ranges',
        icon: 'MdCalendar',
        redirect: '/dashboard/dateRanges'
      },
      {
        name: 'Staff',
        icon: 'IosPeople',
        redirect: '/dashboard/staff'
      },
      {
        name: 'ChangeLogs',
        icon: 'IosFiling',
        redirect: '/dashboard/changeLogs'
      }
      // {
      //   name: 'Calendar Date Ranges',
      //   icon: 'MdCalendar',
      //   redirect: '/dashboard/dateRanges'
      // }
    ]
  },
  {
    name: 'Settings',
    rows: [
      {
        name: 'Account',
        icon: 'IosContact'
      },
      // {
      //   name: 'Admin Users',
      //   icon: 'IosBriefcase'
      // },
      {
        name: 'Log out',
        icon: 'MdExit',
        action: 'logout'
      }
    ]
  }
]

export default content
